import { AfterViewInit, ChangeDetectorRef, Component, DestroyRef, inject, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { faCheck, faEdit, faPencilAlt, faPlusCircle, faTimes } from '@fortawesome/pro-solid-svg-icons';
import { GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { ErrorService } from '../../../../@core/utils/error.service';
import { Room } from '../../models/storage/room';
import { RoomDetail } from '../../models/storage/room-detail';
import { RoomLocation } from '../../models/storage/room-location';
import { RoomService } from '../../services/storage/room-service';
import { WarehouseService } from '../../services/storage/warehouse-service';
import { FilterSettings } from '../../widgets/kw-filter-dropdown/models/filter-options';
import { FilterResults } from '../../widgets/kw-filter-dropdown/models/filter-results';
import { RoomLocationEditComponent } from './room-location-edit/room-location-edit.component';
import { RoomLocationsDataSource } from './room-locations-datasource';
import * as _ from 'underscore';
import { Warehouse } from '../../models/storage/warehouse';
import { KwFilterDropdownService } from '../../widgets/kw-filter-dropdown/kw-filter-dropdown.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'room-locations',
  templateUrl: './room-locations.component.html',
  styleUrls: ['./room-locations.component.css']
})
export class RoomLocationsComponent implements AfterViewInit {
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('grid', { static: false }) grid: GridComponent;
  dataSource: RoomLocationsDataSource;
  public roomLoading = true;
  private initialLoad = true;
  public roomLocations: RoomLocation[] = [];
  private destroyRef = inject(DestroyRef);
  public allRoomLocations: RoomLocation[] = [];
  public filterSettings: Object = {};
  public warehouses: Warehouse[] = [];
  public filter: Object = {};
  public editRoomLocation: RoomLocation = {};
  private bottomSheetSubscription: Subscription;
  public faTimes = faTimes;
  faPencilAlt = faPencilAlt;
  public faCheck = faCheck;
  public faEdit = faEdit;
  public pageSettings: PageSettingsModel = {
    pageSize: 50
  }


  public filterResults: FilterResults;
  public dropdownSettings: FilterSettings = {

    roomSettings: {
      display: true,
      singleSelection: false,
    },
    warehouseSettings: {
      display: true,
      singleSelection: false,
    },
    locationSettings: {
      display: true,
      singleSelection: false,
    }
  };
  get gridMessageAndCount() {
    let pageSize = (this.grid && this.grid.pageSettings) ? this.grid.pageSettings.pageSize: 0;
    let totalCount = (this.grid && this.grid.pageSettings) ? this.grid.pageSettings.totalRecordsCount: 0;
    let currentPage = (this.grid && this.grid.pageSettings) ? this.grid.pageSettings.currentPage : 1;

    let currentPageCount = 0 
    if (pageSize && totalCount) {
      let remaining = totalCount - ((currentPage - 1) * pageSize);
      currentPageCount = remaining > pageSize ? pageSize : (remaining > 0 ? remaining : 0);
    }
    return {
      message: "Narrow results by Warehouse, Room, and Room Location.",
      count: currentPageCount,
      showPdf:false,
      showExcel:false,
      pageSize: pageSize,
      totalCount: totalCount
    };
  }

  public faPlusCircle = faPlusCircle;

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = ['id', 'name'];

  constructor(
    private errorService: ErrorService,
    public service: RoomService,
    private changeDetRef: ChangeDetectorRef,
    private bottomSheet: MatBottomSheet,
    public warehouseService: WarehouseService,
    public filterService: KwFilterDropdownService
    ) {}

  ngAfterViewInit() {
    this.filterSettings = { type: "Menu" };
    this.filter = { type: "CheckBox" }
    this.updateRooms();
  }

  updateRooms() {
    this.roomLoading = true;
    forkJoin([
      this.service.getRoomLocations(),
      this.warehouseService.getWarehouses()
    ]).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:data => {
      this.roomLocations = data[0];
      this.allRoomLocations = data[0];
      this.warehouses = data[1];
      this.roomLoading = false;
    }, error:err => { this.errorService.handleError(err); this.roomLoading = false; }});
  }

  getRoomName(field, data: RoomLocation, column) {
    let value = ""
    if (data.room)
      value = data.room.name;

    return value;
  }

  getWarehouseName(field, data: RoomLocation, column) {
    let value = ""
    if (data.room) {
      if (data.room.warehouse)
        value = data.room.warehouse.name;

    }

    return value;
  }

  editClicked(id: number) {
    this.editRoomLocation = { ...this.roomLocations.filter(u => u.id === id)[0] };
    this.bottomSheet.open(RoomLocationEditComponent, {
      panelClass: 'bottomsheet-60-width', data: {
        roomLocation: { ...this.editRoomLocation }
      }
    });

    this.bottomSheetSubscription = this.bottomSheet._openedBottomSheetRef.afterDismissed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.updateRooms();
      this.bottomSheetSubscription.unsubscribe();
    });
  }

  // getStatus(row: Room){
  //   let status = this.statuses.find(x => x.id == row.statusId)
  //   if(status)
  //     return status.value
  //   else return "";
  // }

  addRoomClicked() {
    this.editRoomLocation = {};
    this.bottomSheet.open(RoomLocationEditComponent, {
    });

    this.bottomSheetSubscription = this.bottomSheet._openedBottomSheetRef.afterDismissed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.updateRooms();
      this.bottomSheetSubscription.unsubscribe();
    });
  }

  deleteRoomClicked(form: NgForm) {
    this.roomLoading = true;
    if (this.editRoomLocation.id !== null && this.editRoomLocation.id !== undefined) {
      this.service.deleteRoom(this.editRoomLocation.id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
        // Keep the filter dropdown cache in sync so other pages drop the deleted room immediately
        this.filterService.removeCached('room', this.editRoomLocation.id);
        this.roomLocations = this.dataSource.data.filter(x => x.id != this.editRoomLocation.id);
        this.dataSource.data = this.dataSource.data.filter(x => x.id != this.editRoomLocation.id);
        this.paginator._changePageSize(this.paginator.pageSize)
        this.editRoomLocation = {};
        this.roomLoading = false;
        form.resetForm();
      }, error:err => { this.errorService.handleError(err); this.roomLoading = false; form.resetForm(); }});
    }
    else {
      alert("No Room Selected!!");
      this.roomLoading = false;
      form.resetForm();
    }
  }

  saveRoomClicked(form: NgForm) {
    this.roomLoading = true;
    if (this.editRoomLocation.isActive === null || this.editRoomLocation.isActive === undefined) { this.editRoomLocation.isActive = false; };
    if (this.editRoomLocation.id !== null && this.editRoomLocation.id !== undefined) {
      this.editRoomLocation.updatedDate = new Date;
      let index = this.dataSource.data.indexOf(this.dataSource.data.filter(w => w.id === this.editRoomLocation.id)[0]);
      this.service.putRoom(this.editRoomLocation).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
        this.filterService.upsertCached('room', this.editRoomLocation);
        //this.dataSource.data[index] = this.editRoomLocation;
        this.dataSource.data = [...this.dataSource.data];
        this.paginator._changePageSize(this.paginator.pageSize);
        this.editRoomLocation = {};
        this.roomLoading = false;
        form.resetForm();
      }, error:err => { this.errorService.handleError(err); this.roomLoading = false; form.resetForm(); }});
    }
    else {
      this.editRoomLocation.id = 0;
      this.editRoomLocation.createdDate = new Date();
      this.editRoomLocation.updatedDate = this.editRoomLocation.createdDate;
      //this.editRoomLocation.locations = [];
      this.service.postRoom(this.editRoomLocation).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
        // this.editRoom.warehouse = this.editWarehouse;
        this.filterService.upsertCached('room', x);
        //this.roomList.push(JSON.parse(JSON.stringify(x)));
        //this.dataSource.data = [...this.roomList];
        this.paginator._changePageSize(this.paginator.pageSize);
        this.editRoomLocation = {};
        this.roomLoading = false;
        form.resetForm();
      }, error:err => { this.errorService.handleError(err); this.roomLoading = false; form.resetForm(); }});
    }
  }

  cancelClicked(form: NgForm) {
    this.editRoomLocation = {};
    //this.getCustomAttributes();
    form.resetForm();
  }


  getValue(row: Room, attrId: number) {
    return row.details.find(x => x.roomCustomAttributeId == attrId).value
  }

  clearDetailValue(typeId: number) {
    //this.editRoomLocation.details.find(x => x.roomCustomAttribute.id === typeId).value = "";
  }

  getDetailName(row: Room, attrId: number) {
    return row.details.find(x => x.id == attrId).roomCustomAttribute.name
  }

  setFilterResults(results: FilterResults) {
    if (this.initialLoad) {
      this.initialLoad = false;
      this.filterResults = this.filterService.getFilterState();
    } else {
      this.filterResults = results;
    }
    this.roomLocations = _.sortBy([
      ...this.allRoomLocations.filter(x =>
        (this.filterResults.selectedWarehouses.length == 0 || this.filterResults.selectedWarehouses.map(y => y.id).includes(x.room.warehouseId)) &&
        (this.filterResults.selectedRooms.length == 0 || this.filterResults.selectedRooms.map(y => y.id).includes(x.roomId)) &&
        (this.filterResults.selectedLocations.length == 0 || this.filterResults.selectedLocations.map(y => y.id).includes(x.id))
      )
    ], x => x.name);
    this.roomLoading = false;

    this.changeDetRef.detectChanges();
  }
}
